import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=d6d1a4a6&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=d6d1a4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d1a4a6",
  null
  
)

export default component.exports